module.exports = __webpack_public_path__ + "static/img/ganju.e90ea3f0.png";